// extracted by extract-css-chunks-webpack-plugin
module.exports = {"title-default":"_1Fwtb-","title-small":"_2aa7Uj"};